import React, { useEffect, useState } from 'react';
// import './AttachedDocuments.css'; // Create this CSS file for styling
import './../assets/css/_attachedDocuments.css'; // Use this line for styling instead of the previous one
import DocumentsItem from '../components/DocumentsItem';
import ClientDocumentPopup from '../clients/documents/_ClientDocumentPopup';
import DeleteAlert from '../components/DeleteAlert';
import { DocumentTypeModel } from '../models/superbit-api-models';
import { ProductionModel } from '../models/ProductionModel';

interface AttachedDocumentsProps {
    setStateFiles: (type: number, fileName: string, value: any) => void;
    deleteFile: (name: number) => void;
    elementaryPolicyDocuments: Array<{
        documentType: DocumentTypeModel;
        createdDate: string;
        elementaryPolicy: any;
        elementaryPolicyDocumentType: number;
        elementaryPolicyId: string;
        filePath: string;
        fileSize: string;
        id: string;
        updatedDate: string;
        user: any;
        userId: string;
    }>;
}

interface DocumentState {
    fileName: string;
    content: File | null;
    type: number;
}

type DocsRecord = Record<string, DocumentState[] | null>;

const ALLOWED_KEYS = ['document7', 'document8', 'document9', 'document10', 'document11'] as const;
type AllowedKey = typeof ALLOWED_KEYS[number];

const AttachedDocuments: React.FC<AttachedDocumentsProps> = ({ setStateFiles, deleteFile, elementaryPolicyDocuments }) => {

    const productionApi : ProductionModel = new ProductionModel();

    const [apiUrl, setApiUrl] = useState<string>('');
    const [clientDocumentUrl, setClientDocumentUrl] = useState<string | null>(null)
    const [validationErrors, setValidationErrors] = useState<Record<string, string>>({});

    const [documents, setDocuments] = useState<DocsRecord>({
        document7: null,
        document8: null,
        document9: null,
        document10: null,
        document11: null,
    });
    const [warnningDeleteFile, setWarnningDeleteFile] = useState<boolean>(false);
    const [deleteTarget, setDeleteTarget] = useState<{ key: AllowedKey; index: number } | null>(null);


    useEffect(() => {
        const savedApiUrl = localStorage.getItem('apiUrl');
        if (savedApiUrl) {
            setApiUrl(savedApiUrl)
        }
        // Map incoming elementaryPolicyDocuments to the documents state
        const updated: DocsRecord = {
            document7: [],
            document8: [],
            document9: [],
            document10: [],
            document11: []
        };

        elementaryPolicyDocuments.forEach((doc) => {
            const t = doc && doc.documentType && doc.documentType.type ? doc.documentType.type : null;
            if (typeof t !== 'number') return;
            const key = `document${t}` as AllowedKey;
            if (!ALLOWED_KEYS.includes(key)) return;

            updated[key]!.push({
                fileName: doc.filePath, // server path/name
                content: null,          // cannot reconstruct File
                type: doc.elementaryPolicyDocumentType
            });
        });

        ALLOWED_KEYS.forEach((k) => {
            if (updated[k] && updated[k]!.length === 0) updated[k] = null;
        });

        setDocuments(updated);
    }, [elementaryPolicyDocuments]);

    const displayClientDocument = (documentUrl: string | null) => {
        setClientDocumentUrl(documentUrl)
    }
    const hideClientDocument = () => {
        setClientDocumentUrl(null)
    }

    // Handle file change for each input

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, docKey: string, type: number) => {
        const fileUploaded = event.target.files ? event.target.files[0] : null;

        if (fileUploaded) {
            const fileSizeMB = (fileUploaded.size / 1024 / 1024).toFixed(2);
            if (parseFloat(fileSizeMB) > 5) {
                setValidationErrors((prev) => ({
                    ...prev,
                    [docKey]: 'גודל הקובץ לא יכול לחרוג מ 5MB.',
                }));
                return;
            }

            const reader = new FileReader();
            reader.onloadend = async () => {
                const stampedName = `${new Date().getTime()}_${fileUploaded.name}`;
                    
                // call to api server to upload file and get path and set the path as fileName in Documents State
                const url = await productionApi.UploadFile2({ filename:fileUploaded.name, content: reader.result});
                                

                setStateFiles(type, fileUploaded.name, url);

                console.log('onloadend', stampedName, reader.result)
                setDocuments((prev) => {
                    const current = prev[docKey] ? prev[docKey]! : [];
                    return {
                        ...prev,
                        [docKey]: [...current, { type, fileName: url, content: fileUploaded }]
                    };
                });
                setValidationErrors((prev) => ({
                    ...prev,
                    [docKey]: '', // Clear validation error
                }));
            };
            reader.readAsDataURL(fileUploaded);
        }
    };

    const handleDelete = (docKey: AllowedKey, index: number) => {
        const list = documents[docKey];
        if (!list || index < 0 || index >= list.length) return;

        const toRemove = list[index];
        if (toRemove) {
            deleteFile(toRemove.type);
        }

        setDocuments((prev) => {
            const nextArr = [...prev[docKey] || []];
            nextArr.splice(index, 1);
            return {
                ...prev,
                [docKey]: nextArr.length ? nextArr : null
            };
        });

        setValidationErrors((prev) => ({ ...prev, [docKey]: '' }));
    };

    return (
        <div className="attached-documents-container">
            <h3 className="documents-title">צירוף מסמכים</h3>
            {[
                { title: 'רישיון רכב- רשות', key: 'document7', type: 7 },
                { title: 'אישור מיגון- מקוד מיגון מסויים חובה', key: 'document8', type: 8 },
                { title: 'שעבוד- רשות', key: 'document9', type: 9 },
                { title: 'העדר תביעות- רשות', key: 'document10', type: 10 },
                { title: 'כללי- מסמכים נוספים', key: 'document11', type: 11 },
            ].map(({ title, key, type }) => {
                const k = key as AllowedKey;
                return (
                    <DocumentsItem
                        key={k}
                        title={title}
                        type={type}
                        // ⬇️ Update DocumentsItem to accept arrays: DocumentState[] | null
                        documentFile={documents[k]}
                        error={validationErrors[k]}
                        // Called when user picks a file to add
                        handleFileChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            handleFileChange(event, k, type)
                        }
                        // Called when user clicks delete on a specific item (pass its index)
                        handleDelete={(index: number) => {
                            setWarnningDeleteFile(true);
                            setDeleteTarget({ key: k, index });
                        }}
                        // So the row can pre-set which item is about to be deleted (optional)
                        setFileKeyForDelete={(index: number) => setDeleteTarget({ key: k, index })}
                        displayClientDocument={displayClientDocument}
                        apiUrl={apiUrl}
                    />
                )
            })}

            {
                clientDocumentUrl != null ?
                    (
                        <ClientDocumentPopup
                            ClosePopup={hideClientDocument}
                            documentUrl={clientDocumentUrl}
                        />
                    ) : ""
            }

            {warnningDeleteFile && (
                <DeleteAlert
                    show={warnningDeleteFile}
                    onClose={() => setWarnningDeleteFile(false)}
                    onConfirm={() => {
                        setWarnningDeleteFile(false);
                        if (deleteTarget) handleDelete(deleteTarget.key, deleteTarget.index);
                        setDeleteTarget(null);
                    }}
                />
            )}
        </div>
    );
};

export default AttachedDocuments;
